import { IAccordion } from './components/blocks/Accordion';
import { IAnimatedCard } from './components/blocks/AnimatedCard';
import { IArticleTopic } from './components/blocks/ArticleTopicCard';
import { IStory } from './components/blocks/BlogArticleCard';
import { INewsCard } from './components/blocks/NewsCard';
import { RunningLineItem } from './components/blocks/RunningLine';
import { DropdownItem } from './components/ui/MoreDropdown';
import { PathEnum } from './types/enums';

export const websites = [
    {
        name: 'Culture Queer',
        url: 'https://image-nation.org/',
    },
    {
        name: 'Long Film Festival',
        url: 'https://image-nation.org/long-film-festival',
    },
    {
        name: 'Short Film Festival',
        url: 'https://image-nation.org/short-film-festival',
    },
    {
        name: 'User Profile',
        url: 'https://image-nation.org/user-profile',
    },
    {
        name: 'Admin Panel',
        url: 'https://image-nation.org/admin',
    },
    {
        name: 'API Url',
        url: 'https://image-nation.org/api',
    },
    {
        name: 'Ticketing System',
        url: 'https://image-nation.org/tickets',
    },
    {
        name: 'Interactive Map',
        url: 'https://image-nation.org/films-map',
    },
];

export const selectedLocaleLocalStorageKey = 'selectedLocale';

export const notFoundPathName = 'NotFound';

export const lffLink = 'https://image-nation.org/festival-2024';

export const moreLinks = (t: Function): DropdownItem[] => [
    // {
    //     title: t('Header.news'),
    //     link: PathEnum.News,
    // },
    {
        title: t('Header.questions'),
        link: PathEnum.Questions,
    },
    {
        title: t('Header.partners'),
        link: PathEnum.Partners,
    },
];

export const articleTopics = (t: Function): IArticleTopic[] => [
    {
        imageSrc: '/images/blog/articles/1.webp',
        title: t('Articles.1.title'),
        text: t('Articles.1.text'),
        link: PathEnum.Explore,
    },
    {
        imageSrc: '/images/blog/articles/2.webp',
        title: t('Articles.2.title'),
        text: t('Articles.2.text'),
        link: PathEnum.ComingSoon,
    },
    {
        imageSrc: '/images/blog/articles/3.webp',
        title: t('Articles.3.title'),
        text: t('Articles.3.text'),
        link: PathEnum.Museum,
    },
    // {
    //     imageSrc: '/images/blog/articles/4.webp',
    //     title: t('Articles.4.title'),
    //     text: t('Articles.4.text'),
    //     link: PathEnum.ComingSoon,
    // },
];

export const stories = (t: Function): IStory[] => [
    {
        imageSrc: '/images/blog/stories/1.webp',
        title: t('Stories.1.title'),
        text: t('Stories.1.text'),
        link: PathEnum.ComingSoon,
    },
    {
        imageSrc: '/images/blog/stories/2.webp',
        title: t('Stories.2.title'),
        text: t('Stories.2.text'),
        link: PathEnum.FilmSubmission,
    },
];

export const watchItems = (t: Function): IAnimatedCard[] => [
    {
        imageSrc: '/images/watch/1.webp',
        title: t('Watch.1.title'),
        text: t('Watch.1.text'),
        link: lffLink,
    },
    {
        imageSrc: '/images/watch/2.webp',
        title: t('Watch.2.title'),
        text: t('Watch.2.text'),
        // link: 'https://image-nation.org/festival-courts-shorts',
        link: PathEnum.ComingSoon,
    },
    {
        imageSrc: '/images/watch/3.webp',
        title: t('Watch.3.title'),
        text: t('Watch.3.text'),
        link: PathEnum.ComingSoon,
    },
];

export const news = (t: Function): INewsCard[] => [
    {
        imageSrc: '/images/news/1.webp',
        title: t('News.1.title'),
        text: t('News.1.text'),
        link: PathEnum.ComingSoon,
    },
    {
        imageSrc: '/images/news/2.webp',
        title: t('News.2.title'),
        text: t('News.2.text'),
        link: PathEnum.ComingSoon,
    },
    {
        imageSrc: '/images/news/3.webp',
        title: t('News.3.title'),
        text: t('News.3.text'),
        link: PathEnum.ComingSoon,
    },
];

export const runningLineItems = (t: Function): RunningLineItem[] => [
    {
        type: 'text',
        content: t('RunningLine.text1'),
    },
    {
        type: 'text',
        content: t('RunningLine.text2'),
    },
];

export const donateLinkEn = 'https://donorbox.org/donate-now-to-encourage-lgbtq-storytelling';
export const donateLink =
    'https://donorbox.org/faire-un-don-et-encouragez-la-diffusion-d-histoires-lgbtq';

export const footerLinks = (t: Function): { href: string; title: string }[] => [
    {
        href: '/#questions',
        title: t('Buttons.faq'),
    },
    {
        href: '/#questions',
        title: t('Buttons.contactUs'),
    },
    // {
    //     href: PathEnum.SupportUs,
    //     title: t('FooterLinks.supportUs'),
    // },
    // {
    //     href: PathEnum.BecomeAVolunteer,
    //     title: t('FooterLinks.becomeAVolunteer'),
    // },
];

export const socials = (t: Function): { href: string; title: string }[] => [
    {
        href: 'https://www.facebook.com/imagenationMTL',
        title: t('Socials.facebook'),
    },
    {
        href: 'https://www.instagram.com/imagenationmtl?igsh=ZmRoemxrcmNnOGJr',
        title: t('Socials.instagram'),
    },
    {
        href: 'https://www.linkedin.com/company/imagenationmtl',
        title: t('Socials.linkedIn'),
    },
    {
        href: 'https://www.youtube.com/user/imagenationxx',
        title: t('Socials.youTube'),
    },
];

export const partners = (
    t: Function,
): { logoSrc: string; title: string; texts: string[]; url: string }[] => [
    {
        logoSrc: '/images/partners/1.webp',
        title: t('Partners.1.title'),
        texts: [t('Partners.1.texts.1'), t('Partners.1.texts.2')],
        url: t('Partners.1.url'),
    },
    {
        logoSrc: '/images/partners/2.webp',
        title: t('Partners.2.title'),
        texts: [t('Partners.2.texts.1'), t('Partners.2.texts.2')],
        url: t('Partners.2.url'),
    },
    {
        logoSrc: '/images/partners/3.webp',
        title: t('Partners.3.title'),
        texts: [t('Partners.3.texts.1'), t('Partners.3.texts.2')],
        url: t('Partners.3.url'),
    },
    {
        logoSrc: '/images/partners/4.webp',
        title: t('Partners.4.title'),
        texts: [t('Partners.4.texts.1')],
        url: t('Partners.4.url'),
    },
    {
        logoSrc: '/images/partners/5.webp',
        title: t('Partners.5.title'),
        texts: [t('Partners.5.texts.1')],
        url: t('Partners.5.url'),
    },
    {
        logoSrc: '/images/partners/6.webp',
        title: t('Partners.6.title'),
        texts: [t('Partners.6.texts.1'), t('Partners.6.texts.2')],
        url: t('Partners.6.url'),
    },
    {
        logoSrc: '/images/partners/7.webp',
        title: t('Partners.7.title'),
        texts: [t('Partners.7.texts.1'), t('Partners.7.texts.2')],
        url: t('Partners.7.url'),
    },
    {
        logoSrc: '/images/partners/8.webp',
        title: t('Partners.8.title'),
        texts: [t('Partners.8.texts.1')],
        url: t('Partners.8.url'),
    },
];

export const topics = (t: Function): { label: string; value: string }[] => [
    { label: t('Topics.generalInquiries'), value: t('Topics.generalInquiries') },
    { label: t('Topics.festivalOrEventQuestion'), value: t('Topics.festivalOrEventQuestion') },
    { label: t('Topics.filmSubmissions'), value: t('Topics.filmSubmissions') },
    {
        label: t('Topics.partnershipsOrSponsorships'),
        value: t('Topics.partnershipsOrSponsorships'),
    },
    { label: t('Topics.pressOrMediaInquiries'), value: t('Topics.pressOrMediaInquiries') },
    { label: t('Topics.donationsAndSupport'), value: t('Topics.donationsAndSupport') },
    {
        label: t('Topics.technicalIssuesOrWebsiteFeedback'),
        value: t('Topics.technicalIssuesOrWebsiteFeedback'),
    },
];

export const questions = (t: Function): IAccordion[] => [
    { title: t('Faq.1.q'), text: t('Faq.1.a') },
    { title: t('Faq.2.q'), text: t('Faq.2.a') },
    { title: t('Faq.3.q'), text: t('Faq.3.a') },
    { title: t('Faq.4.q'), text: t('Faq.4.a') },
    { title: t('Faq.5.q'), text: t('Faq.5.a') },
    { title: t('Faq.6.q'), text: t('Faq.6.a') },
    { title: t('Faq.7.q'), text: t('Faq.7.a') },
    { title: t('Faq.8.q'), text: t('Faq.8.a') },
    { title: t('Faq.9.q'), text: t('Faq.9.a') },
    { title: t('Faq.10.q'), text: t('Faq.10.a') },
    { title: t('Faq.11.q'), text: t('Faq.11.a') },
    { title: t('Faq.12.q'), text: t('Faq.12.a') },
    { title: t('Faq.13.q'), text: t('Faq.13.a') },
    { title: t('Faq.14.q'), text: t('Faq.14.a') },
    { title: t('Faq.15.q'), text: t('Faq.15.a') },
];

export const skills = (t: Function): { label: string; value: string }[] => [
    { label: t('Skills.skill1'), value: t('Skills.skill1') },
    { label: t('Skills.skill2'), value: t('Skills.skill2') },
    { label: t('Skills.skill3'), value: t('Skills.skill3') },
    { label: t('Skills.skill4'), value: t('Skills.skill4') },
    { label: t('Skills.skill5'), value: t('Skills.skill5') },
    { label: t('Skills.skill6'), value: t('Skills.skill6') },
    { label: t('Skills.skill7'), value: t('Skills.skill7') },
    { label: t('Skills.skill8'), value: t('Skills.skill8') },
    { label: t('Skills.skill9'), value: t('Skills.skill9') },
    { label: t('Skills.skill10'), value: t('Skills.skill10') },
    { label: t('Skills.skill11'), value: t('Skills.skill11') },
    { label: t('Skills.skill12'), value: t('Skills.skill12') },
    { label: t('Skills.skill13'), value: t('Skills.skill13') },
];
